"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateProfile = exports.signOut = exports.signIn = exports.getProfile = exports.getMerchantName = exports.changeMerchant = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _profile = require("@widget/profile");

var _logger = require("@package/logger");

var _notification = require("@widget/notification");

var _request = _interopRequireDefault(require("@package/request"));

var _socket = require("@package/socket");

var _slice = require("./slice");

var getProfile = function getProfile() {
  var isSilent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(dispatch) {
      var result, _result$data, merchants, user, activeMerchant, savedMerchantId, _merchants$filter, _merchants$filter2, foundMerchant, _merchants, firstMerchant;

      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              dispatch((0, _slice.getProfileRequestAction)());
              _context.next = 4;
              return (0, _request["default"])({
                url: '/profiles/get',
                method: 'get'
              });

            case 4:
              result = _context.sent;
              _result$data = result.data, merchants = _result$data.merchants, user = _result$data.user;
              savedMerchantId = window.localStorage.getItem('merchantId') || null;

              if (savedMerchantId) {
                _merchants$filter = merchants.filter(function (merchant) {
                  return merchant['id'] === Number(savedMerchantId);
                }), _merchants$filter2 = (0, _slicedToArray2["default"])(_merchants$filter, 1), foundMerchant = _merchants$filter2[0];

                if (foundMerchant) {
                  activeMerchant = foundMerchant;
                } else {
                  activeMerchant = merchants[0];
                }
              } else {
                _merchants = (0, _slicedToArray2["default"])(merchants, 1), firstMerchant = _merchants[0];
                activeMerchant = firstMerchant;
              }

              window.localStorage.setItem('merchantId', activeMerchant['id']);
              (0, _socket.joinToRoom)(activeMerchant['id'] + "_" + user['id']);
              dispatch((0, _slice.getProfileRequestSuccessAction)({
                merchant: activeMerchant,
                user: user
              }));
              dispatch((0, _slice.setAvailableMerchants)(merchants));
              dispatch((0, _notification.getNotifications)());

              if (!isSilent) {
                _profile.events.emit('auth', {
                  merchant: activeMerchant,
                  user: user
                });
              }

              return _context.abrupt("return", true);

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](0);
              dispatch((0, _slice.getProfileRequestFailAction)(_context.t0));

              if (!isSilent) {
                _profile.events.emit('not-auth', _context.t0);
              }

              return _context.abrupt("return", false);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 17]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getProfile = getProfile;

var signIn = function signIn(formData) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(dispatch) {
      var result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              dispatch((0, _slice.signInRequestAction)());
              _context2.next = 4;
              return (0, _request["default"])({
                url: '/sign-in',
                method: 'post',
                data: {
                  email: formData['email'].trim(),
                  password: String(formData['password']).trim()
                }
              });

            case 4:
              result = _context2.sent;
              dispatch((0, _slice.signInRequestSuccessAction)(result));
              _context2.next = 8;
              return dispatch(getProfile(true));

            case 8:
              return _context2.abrupt("return", _context2.sent);

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](0);
              _context2.t1 = _context2.t0['status'];
              _context2.next = _context2.t1 === 401 ? 16 : _context2.t1 === 423 ? 18 : 20;
              break;

            case 16:
              dispatch((0, _slice.signInRequestFailAction)('Пользователь с парой логин/пароль не найден'));
              return _context2.abrupt("break", 21);

            case 18:
              dispatch((0, _slice.signInRequestFailAction)("\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u043E\u043F\u044B\u0442\u043E\u043A \u0432\u0445\u043E\u0434\u0430. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430 \u0447\u0435\u0440\u0435\u0437 ".concat(_context2.t0['data']['retryDelayMinutes'], " \u043C\u0438\u043D")));
              return _context2.abrupt("break", 21);

            case 20:
              dispatch((0, _slice.signInRequestFailAction)('Непредвиденная ошибка'));

            case 21:
              return _context2.abrupt("return", false);

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 11]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.signIn = signIn;

var signOut = function signOut(merchantId, userId) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(dispatch) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              dispatch((0, _slice.signOutRequestAction)());
              _context3.next = 4;
              return (0, _request["default"])({
                url: '/sign-out',
                method: 'post',
                data: {}
              });

            case 4:
              (0, _socket.leaveFromRoom)(merchantId + '_' + userId);
              dispatch((0, _slice.signOutRequestSuccessAction)());
              dispatch((0, _slice.resetStateAction)());
              return _context3.abrupt("return", true);

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](0);
              dispatch((0, _slice.signOutRequestFailAction)(_context3.t0));
              return _context3.abrupt("return", false);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 10]]);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.signOut = signOut;

var changeMerchant = function changeMerchant(currentMerchant, nextMerchant, profile) {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4(dispatch) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              (0, _logger.push)({
                owner: 'Application',
                message: "\u0421\u043C\u0435\u043D\u0430 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430 c ".concat(currentMerchant['id'], " \u043D\u0430 ").concat(nextMerchant['id'])
              });
              dispatch((0, _slice.setLoadingProcessAction)(true));
              (0, _socket.leaveFromRoom)(currentMerchant['id'] + "_" + profile['user']['id']);
              dispatch((0, _slice.changeMerchantAction)(nextMerchant));
              window.localStorage.setItem('merchantId', nextMerchant['id']);
              (0, _logger.push)({
                owner: 'Application',
                message: "\u0421\u043C\u0435\u043D\u0430 \u043C\u0435\u0440\u0447\u0430\u043D\u0442\u0430 c ".concat(currentMerchant['id'], " \u043D\u0430 ").concat(nextMerchant['id'], " \u043F\u0440\u043E\u0448\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E")
              });
              _context4.next = 8;
              return dispatch(getProfile(true));

            case 8:
              return _context4.abrupt("return", _context4.sent);

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.changeMerchant = changeMerchant;

var getMerchantName = function getMerchantName(merchant) {
  if (merchant['type'] === 'INDIVIDUAL') {
    var _merchant$profile$ind = merchant['profile']['individualData']['individual'],
        _merchant$profile$ind2 = _merchant$profile$ind.firstName,
        firstName = _merchant$profile$ind2 === void 0 ? '' : _merchant$profile$ind2,
        _merchant$profile$ind3 = _merchant$profile$ind.surname,
        surname = _merchant$profile$ind3 === void 0 ? '' : _merchant$profile$ind3,
        _merchant$profile$ind4 = _merchant$profile$ind.patronymic,
        patronymic = _merchant$profile$ind4 === void 0 ? '' : _merchant$profile$ind4;
    var name = [surname, firstName, patronymic].join(' ').replace(/^\s+|\s+$/, '');
    return name || 'Не указано';
  }

  if (merchant['type'] === 'LEGAL') {
    var _merchant$profile$leg = merchant['profile']['legalData']['legal'].nameRu,
        nameRu = _merchant$profile$leg === void 0 ? '' : _merchant$profile$leg;
    return nameRu || 'Не указано';
  }

  if (merchant['type'] === 'ST') {
    var _merchant$profile$sol = merchant['profile']['soleTraderData']['soleTrader'].fullName,
        fullName = _merchant$profile$sol === void 0 ? '' : _merchant$profile$sol;
    return fullName || 'Не указано';
  }
};

exports.getMerchantName = getMerchantName;

var updateProfile = function updateProfile(merchantData) {
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5(dispatch) {
      var result, status, message;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              (0, _logger.push)({
                message: 'Обновление данных пользователя'
              });
              dispatch((0, _slice.changeTypeRequestAction)());
              _context5.next = 5;
              return (0, _request["default"])({
                url: '/profiles/update',
                method: 'put',
                data: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, merchantData), {}, {
                  type: merchantData['type'].toUpperCase()
                })
              });

            case 5:
              result = _context5.sent;
              dispatch((0, _slice.changeTypeRequestSuccessAction)(result['data']));
              _context5.next = 16;
              break;

            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](0);
              status = _context5.t0['status'];
              message = '';

              if (status > 400) {
                message = "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437 (\u043A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438: ".concat(_context5.t0['data']['code'], ")");
              }

              dispatch((0, _slice.changeTypeRequestFailAction)({
                status: status,
                message: message,
                code: _context5.t0['data']['code']
              }));
              (0, _logger.push)({
                message: 'Ошибка при обновлении данных пользователя'
              });

            case 16:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 9]]);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};

exports.updateProfile = updateProfile;